/**
 * loanTypeUtil.js
 *
 * Provides a live getLoanType() helper that reads pageViewState
 * from the Redux store and returns the correct loan type string.
 */

let _store = null;
let listener = null;

/**
 * Register a listener to be notified when the loan type changes based on store updates.
 */
export const registerLoanTypeListener = (cb) => {
    listener = cb;
};

/**
 * Call this once after the Redux store is created
 * so that getLoanType() can access the store without importing it circularly.
 */
export const injectStore = (store) => {
    _store = store;
    
    // Subscribe to store updates to notify registered listener
    store.subscribe(() => {
        const state = store.getState();
        const pageViewState = state?.CRMMenu?.pageViewState ?? "";
        const currentLoanType = pageViewState === "SvlLoanApplications" || pageViewState === "SvlApplications" || pageViewState === "SvlApprovedLeads" || pageViewState === "SvlDisburseByIcici" ? "SVL" : "BL";
        if (listener) {
            listener(currentLoanType);
        }
    });
};

/**
 * Returns the active loan type derived from the current pageViewState in Redux.
 *   pageViewState === "SvlLoanApplications"  →  "SVL"
 *   anything else                             →  "BL"
 */
export const getLoanType = () => {
    if (_store) {
        const state = _store.getState();
        const pageViewState = state?.CRMMenu?.pageViewState ?? "";
        return pageViewState === "SvlLoanApplications" ? "SVL" : "BL";
    }
    // Fallback before store is injected
    return "BL";
};
